import { writable } from "svelte/store";

export const categories = writable({
    "veggies": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "fruits": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "herbs": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "meat": {
        "options": [{"organic":false}, {"boneless":false}, {"skinless":false}],
        "flavors": [],
        "cuts": [
            "back ribs",
            "bavette",
            "belly",
            "bottom round",
            "boston butts",
            "breast",
            "brisket" ,
            "brisket flat", 
            "brisket point",
            "cheeks",
            "chops",  
            "chuck",
            "chuck eye",
            "chuck roast",
            "chuck steak", 
            "country-style ribs",
            "crown roast",
            "cutlets",
            "denver steak", 
            "drumstick",
            "eye of round",
            "fillet",
            "fillet mignon",
            "flank steak" ,
            "flat iron steak",
            "ground",
            "ham",
            "jaw",
            "kabobs",
            "hanger steak",
            "leg",
            "liver",
            "loin",
            "loin roast",
            "loin chops",
            "medallions", 
            "neck",
            "new york strip",
            "oxtail",
            "picnic roast",
            "porterhouse steak", 
            "prime rib",   
            "pulled",
            "ranch steak",
            "roast",          
            "round",
            "ribeye cap steak",
            "ribeye steak",
            "shank", 
            "short ribs",  
            "shoulder",
            "sirloin", 
            "sirloin cap",
            "sirloin tip",
            "skirt steak",
            "spare ribs",
            "stew meat",
            "strip steak",
            "t-bone steak",
            "tenderloin", 
            "thigh",
            "top blade steak",
            "top round", 
            "top sirloin", 
            "tongue",
            "tri-tip" ,
            "wing", 
            "whole"
        ]
    },
    "seafood": {
        "options": [{"organic":false}, {"deveined":false}, {"wild caught":false}, {"breaded":false}],
        "flavors": [],
        "cuts": ["fillet", "whole", "steak", "darne", "tail", "head"]
    },
    "dairy": {
        "options": [{"organic":false}, {"whole":false}, {"low fat":false}, {"fat free":false}, {"lactose free":false}, {"unsweetened":false}],
        "flavors": ["chocolate", "vanilla", "strawberry", "hazelnut", "maple syrup"],
        "cuts": []
    },
    "cheese": {
        "options": [{"organic":false}, {"shredded": false}, {"sliced":false}, {"low fat":false}],
        "flavors": [],
        "cuts": []
    },
    "deli": {
        "options": [{"organic":false},{"uncured":false},{"cured":false},{"sliced":false},{"smoked":false}],
        "flavors": [],
        "cuts": []
    },
    "ready-made": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "condiments": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "spices": {
        "options": [{"organic":false}, {"mild":false}, {"hot":false}, {"ground":false}],
        "flavors": [],
        "cuts": []
    },
    "oil": {
        "options": [{"organic":false}, {"spray":false}],
        "flavors": [],
        "cuts": []
    },
    "snacks": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "nuts": {
        "options": [{"organic":false},{"raw":false},{"roasted":false},{"unsalted":false},{"salted":false},{"sliced":false},{"shelled":false}],
        "flavors": [],
        "cuts": []
    },
    "baking": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "cereals": {
        "options": [{"organic":false}, {"gluten free":false}, {"whole grain":false}],
        "flavors": [],
        "cuts": []
    },
    "bakery": {
        "options": [{"organic":false}, {"gluten free":false}, {"whole grain":false}],
        "flavors": [],
        "cuts": []
    },
    "beverages": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "coffee tea": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "alcohol": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "canned": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "frozen": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "personal care": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "baby": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "household": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "pet": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
    "misc": {
        "options": [{"organic":false}],
        "flavors": [],
        "cuts": []
    },
});